'use client'

import type { TypeButtonBlockFields } from '@lib/generated-types/TypeButtonBlock'
import { ButtonBlock as Block } from '@shc/ui'
import Analytics from '@components/analytics'
import type { SPEvent, SPContext } from '@hooks/use-analytics'
import { routeMapper } from '@lib/menu-item-mapper'
import { pyMap } from '@lib/token-maps'

const ButtonBlock = ({
  internalName,
  button1Label,
  button1AnchorOrExternalLink,
  button1Link,
  button1Style,
  button2Label,
  button2AnchorOrExternalLink,
  button2Link,
  button2Style,
  paddingTop,
  paddingBottom,
  blockalignment,
  ...props
}: TypeButtonBlockFields) => {
  const link1 = routeMapper(button1Link, button1AnchorOrExternalLink)
  const link2 = routeMapper(button2Link, button2AnchorOrExternalLink)

  const analyticsEvent = (label: string | undefined, link: string) => {
    if( !label || !link ){
      return {}
    }
    return {
      click: {
        name: 'component_click',
        data: {},
      } as SPEvent,
      contexts: [
        {
          name: 'component',
          data: {
            component_text: label,
            component_url: link,
          },
        },
      ] as SPContext[],
    }
  }

  return (
      <Block
        alignment={blockalignment}
        paddingBottom={pyMap[paddingBottom] as 'none' | 'sm' | 'lg' | 'xl' | '2xl' | 'md'}
        paddingTop={pyMap[paddingTop] as 'none' | 'sm' | 'lg' | 'xl' | '2xl' | 'md'}
        buttonPrimary={{
          label: button1Label,
          variant: button1Style === "primary" ? "filled" : "outlined",
          href: link1.route,
          target: link1.isInternal ? undefined : "_blank",
          rel: link1.isInternal ? undefined : "noopener noreferrer",
          color: "primary",
        }}
        buttonSecondary={ button2Label ? {
          label: button2Label,
          variant: button2Style === "primary" ? "filled" : "outlined",
          href: link2.route,
          target: link2.isInternal ? undefined : "_blank",
          rel: link2.isInternal ? undefined : "noopener noreferrer",
          color: "primary",
        } : undefined }
        slotProps={{
          buttonPrimaryContainer: analyticsEvent(button1Label, link1.route),
          buttonSecondaryContainer: analyticsEvent(button2Label, link2.route),
        }}
        slots={{
          buttonPrimaryContainer: Analytics,
          buttonSecondaryContainer: button2Label ? Analytics : undefined,
        }}
      />
  )
}

export default ButtonBlock
